var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.last_name = require("./last_name");